<template>
    <div class="row-space">
        <slot name="header">
            <div class="search-preference__title">
                <slot name="label">
                    <span v-html="label" />
                </slot>
            </div>
        </slot>
        <slot />
    </div>
</template>

<script>
export default {
    props: {
        label: {
            type: String,
            default: '',
        },
    },
};
</script>
